import t from"./AccountId.js";import r from"../ObjectMap.js";class o extends r{constructor(){super(r=>t.fromString(r))}toJSON(){const t={};return this._map.forEach((r,o)=>{t[o]=r.toString()}),t}}export{o as default};
//# sourceMappingURL=TokenTransferAccountMap.js.map
